const CART_STATES_CONSTANTS = {
  FROMCONFIRM: 'FROMCONFIRM',
};
export default CART_STATES_CONSTANTS;
